import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ElementoMenuHijo } from '../panel-menu/elemento-menu-hijo';

@Component({
  selector: 'app-elemento-hijo-menu',
  templateUrl: './elemento-hijo-menu.component.html',
  styleUrl: './elemento-hijo-menu.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ElementoHijoMenuComponent {
  @Input() elementoHijo!: ElementoMenuHijo;
  @Output() childMenuClick = new EventEmitter<void>();

  onChildMenuClick() {
    this.childMenuClick.emit();
  }
}
